import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, ButtonProps } from '@mis/sushi-tailwind-react';
import React from 'react';

const Red = styled(Button)`
  ${({ disabled, loading }) =>
    !disabled &&
    !loading &&
    css`
      color: #ffffff;
      background: linear-gradient(180deg, #d9598a 0%, #c60650 88%);
      :hover {
        background: #c60650;
      }
      :active {
        box-shadow: 0 0 0 1px #d9598a;
      }
    `}
`;

export const RedButton: React.FC<ButtonProps> = (props) => {
  return <Red type="button" data-testid="btnRed" {...props} />;
};
